import { fonts, colors } from '../../../styles'

export default {
	fontFamily: fonts.header,
	color: colors.white,
	fontSize: 32,
	marginTop: 16,
	marginBottom: 30
}



// WEBPACK FOOTER //
// ./src/components/format/Header/styles.js